import{DEFAULT_ALGOLIA_HIERARCHY_DIVIDER as o}from"../../consts/hierarchy.js";const r=(r,s=o)=>r?r.split(s):[];export{r as getHierarchyArray};
